import type { Release } from '../releases.ts';

export default {
  version: '0.17.2',
  date: '2026-10-02',
  title: 'Temporary files',
  summary: [
    'Housekeeping finds temporary files nothing refers to, and removes them when you confirm',
    'Media workers remove work folders left by a stopped worker after a day',
    'Unfinished uploads are removed after a day',
    'Fixed: renders of a failed export are no longer left behind',
  ],
  features: [
    'System status → Housekeeping → Temporary files: a scan lists files in storage that nothing in PRISM refers to (such as output of transcodes or exports that failed after writing it), by location and kind with sizes, and removes them only when you confirm',
    'Media workers remove work folders left by a worker that stopped mid-job once nothing has touched them for a day; running jobs, including live recordings waiting for a stream, are never removed',
    'Uploads left unfinished for a day are removed with their staging files, every hour',
  ],
  fixes: ['Renders of a failed export are no longer left in the exports tier for good'],
} satisfies Release;
